module.exports = __webpack_public_path__ + "img/check.f04ce119.svg";